<div class="event-status-container"
     [ngSwitch]="eventTypeMapper[type]?.type"
     [title]="eventTypeMapper[type]?.text | titlecase">
  <!--  matTooltip="{{eventTypeMapper[type].text | titlecase}}"-->
  <!--  matTooltipPosition="right"-->
  <!--  matTooltipHideDelay="1000"-->
  <app-svg [svg]="eventTypeMapper[type]?.key" *ngSwitchCase="'svg'" [ngClass]="eventTypeMapper[type]?.key | lowercase">
  </app-svg>
  <div class="icon-{{eventTypeMapper[type]?.key}}" *ngSwitchCase="'font'"></div>
</div>
